var _rect, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHouseholdContentInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-39 -14C-39 -20.6274 -33.6274 -26 -27 -26H139C145.627 -26 151 -20.6274 151 -14V161.231C151 167.858 145.627 173.231 139 173.231H-27C-33.6274 173.231 -39 167.858 -39 161.231V-14Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_2721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_2721)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9996 24.844L35.0635 41.0936V78.2845H82.9358V41.0936L58.9996 24.844Z",
    fill: "#EFD1B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.04 58.3378H55.0108V78.2846H44.04V58.3378Z",
    fill: "#D7AE88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9814 67.3138H79.9442V71.3032H65.9814V67.3138Z",
    fill: "#2C3A64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9893 78.2846V64.3218L64.9839 61.3298L66.9786 64.3218V78.2846H62.9893Z",
    fill: "#4B81AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9678 78.2846V64.3218L72.9625 61.3298L74.9571 64.3218V78.2846H70.9678Z",
    fill: "#4B81AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9463 78.2846V64.3218L80.941 61.3298L82.9356 64.3218V78.2846H78.9463Z",
    fill: "#4B81AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9917 49.3617H56.0076C54.3551 49.3617 53.0156 48.0223 53.0156 46.3697V40.3856C53.0156 38.733 54.3551 37.3936 56.0076 37.3936H61.9917C63.6443 37.3936 64.9837 38.733 64.9837 40.3856V46.3697C64.9837 48.0223 63.6443 49.3617 61.9917 49.3617Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9837 42.3803H59.997V37.3936H58.0023V42.3803H53.0156V44.375H58.0023V49.3617H59.997V44.375H64.9837V42.3803Z",
    fill: "#B0D2EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0244 67.3138H52.0191V69.3085H50.0244V67.3138Z",
    fill: "#2C3A64"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0664 70.3058H36.0611V78.2846H34.0664V70.3058Z",
    fill: "#2A5B43"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0506 66.3164C40.0506 69.8968 37.8175 72.3004 35.0639 72.3004C32.3102 72.3004 30.0771 69.8968 30.0771 66.3164C30.0771 63.9786 32.2025 58.3177 33.6785 54.6685C34.1832 53.4208 35.9455 53.4208 36.4502 54.6685C37.9252 58.3177 40.0506 63.9786 40.0506 66.3164Z",
    fill: "#3A8761"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0801 77.2872C29.0801 76.5822 29.6516 76.0106 30.3567 76.0106H87.6439C88.349 76.0106 88.9205 76.5822 88.9205 77.2872V78.5191C88.9205 79.2242 88.349 79.7957 87.6439 79.7957H30.3567C29.6516 79.7957 29.0801 79.2242 29.0801 78.5191V77.2872Z",
    fill: "#031C2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5226 41.9773C86.1267 42.5607 85.3329 42.7128 84.7494 42.3169L59.7171 25.3306C59.2843 25.0369 58.7162 25.0369 58.2835 25.3306L33.2511 42.3169C32.6677 42.7128 31.8738 42.5607 31.478 41.9773L30.6715 40.7888C30.2757 40.2054 30.4277 39.4116 31.0111 39.0157L58.2835 20.5095C58.7162 20.2158 59.2843 20.2158 59.7171 20.5095L86.9895 39.0157C87.5729 39.4116 87.7249 40.2054 87.3291 40.7888L86.5226 41.9773Z",
    fill: "#2A5B43"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_2721",
    x: -59,
    y: -42,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_2721",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHouseholdContentInsurance);
export default __webpack_public_path__ + "static/media/imgHouseholdContentInsurance.9dff1c234dff0ae9c01635ebbc89dce1.svg";
export { ForwardRef as ReactComponent };